export default __webpack_public_path__ + "6c72859e1612bdfb6a2ca43322f3f42b.svg";